// extracted by mini-css-extract-plugin
export default {"icon":"state-icon_icon__n7BH5","normal":"state-icon_normal__Z8ih3"};